function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  id: "LinkedIn_1_",
  d: "M430.1,252v159h-92.2V262.6c0-37.3-13.3-62.7-46.7-62.7c-25.5,0-40.6,17.1-47.3,33.7 c-2.4,5.9-3.1,14.2-3.1,22.5V411h-92.2c0,0,1.2-251.3,0-277.3h92.2V173c-0.2,0.3-0.4,0.6-0.6,0.9h0.6V173 c12.3-18.9,34.1-45.8,83.1-45.8C384.6,127.2,430.1,166.8,430.1,252z M52.2,0C20.6,0,0,20.7,0,47.9c0,26.6,20,47.9,51,47.9h0.6 c32.2,0,52.2-21.3,52.2-47.9C103.1,20.7,83.7,0,52.2,0z M5.5,411h92.2V133.7H5.5V411z"
}));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "430.1px",
    height: "411px",
    viewBox: "0 0 430.1 411",
    style: {
      enableBackground: "new 0 0 430.1 411"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.31b216dc.svg";
export { ForwardRef as ReactComponent };